import { render, staticRenderFns } from "./NoteViewer.vue?vue&type=template&id=a82a9cf2&scoped=true"
import script from "./NoteViewer.vue?vue&type=script&lang=js"
export * from "./NoteViewer.vue?vue&type=script&lang=js"
import style0 from "./NoteViewer.vue?vue&type=style&index=0&id=a82a9cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82a9cf2",
  null
  
)

export default component.exports